import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack, Typography } from 'investira.react.components';
import { objects, strings } from 'investira.sdk';
import SortButton from '../../../components/molecules/SortButton';
import { SearchIndicadores } from '../../../components/organisms';
import {
  INDICADORES_SORT_OPTIONS,
  sanitizeIndicadoresSort
} from '../_shared/indicadoresSortOptions';
import { getIndicadoresTipoRouteContext } from '../_shared/indicadoresTipoRoute';

/** Compõe a busca contextual e o total da listagem de indicadores. */
const IndicadoresTerms = memo(pProps => {
  const xLocation = useLocation();
  const xNavigate = useNavigate();
  const { route: xRoute, tipo: xTipo } = getIndicadoresTipoRouteContext(xLocation.pathname);
  const xQuery = strings.querystringToObject(xLocation.search) || {};
  const xSort = sanitizeIndicadoresSort(xQuery.sort);

  /** Aplica a ordenação, preserva a pesquisa e retorna à primeira página. */
  function pvChangeSort(pSort) {
    const xNextQuery = { ...xQuery };
    const xPathname = xLocation.pathname.replace(/\/page\/\d+$/, '');

    if (pSort) {
      xNextQuery.sort = pSort;
    } else {
      delete xNextQuery.sort;
    }

    const xSearch = Object.keys(xNextQuery).length ? objects.objectToQueryString(xNextQuery) : '';

    xNavigate(`${xPathname}${xSearch}`);
  }

  return (
    <Stack spacing={2} mb={4}>
      <SearchIndicadores
        dataRead={pProps.dataRead}
        pageIsLoading={pProps.pageIsLoading}
        tipoId={xTipo?.id}
        tipoDescricao={xTipo?.descricao}
        resultsPath={`/indicadores/${xRoute}`}
        preserveQuery
      />
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}>
        <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
          {pProps.totalResults} resultados
        </Typography>
        <Stack sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 280 } }}>
          <SortButton
            id="indicadores-sort"
            ariaLabel="Ordenar indicadores"
            value={xSort}
            options={INDICADORES_SORT_OPTIONS}
            onChange={pvChangeSort}
          />
        </Stack>
      </Stack>
    </Stack>
  );
});

IndicadoresTerms.propTypes = {
  dataRead: PropTypes.func.isRequired,
  pageIsLoading: PropTypes.bool,
  totalResults: PropTypes.number
};

IndicadoresTerms.defaultProps = {
  pageIsLoading: false,
  totalResults: 0
};

IndicadoresTerms.displayName = 'IndicadoresTerms';

export default IndicadoresTerms;
